import { ITextField, mergeStyles, Stack, TextField } from '@fluentui/react';
import { useLayoutEffect, useRef } from 'react';

type Props = {
  setPin: React.Dispatch<React.SetStateAction<number | undefined>>;
};

export default ({ setPin }: Props) => {
  const fields = [1, 2, 3, 4].map((_, i) => ({
    index: i,
    ref: useRef<ITextField>(),
  }));

  useLayoutEffect(() => {
    const interval = setInterval(() => {
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i].ref.current;

        if (field && !field.value) {
          field.focus();
          break;
        }
      }
    }, 150);

    return () => clearInterval(interval);
  });

  return (
    <Stack horizontal tokens={stackTokens}>
      {fields.map((field, index) => (
        <TextField
          key={"pin-" + index}
          componentRef={(r) => r && (field.ref.current = r)}
          autoFocus={index === 0}
          className={fieldStyles}
          maxLength={1}
          type="password"
          onChange={(_, nv) => {
            if (!nv) return;

            if (field.index === fields.length - 1) {
              let pinStr = fields.map((f) => f.ref.current?.value).join("");
              if (pinStr.length === 3) pinStr += nv;

              let pinInt: number | undefined = parseInt(pinStr);
              if (isNaN(pinInt)) pinInt = undefined;

              setPin(pinInt);
            } else {
              fields[field.index + 1].ref.current?.focus();
            }
          }}
        />
      ))}
    </Stack>
  );
};

const stackTokens = { childrenGap: 5 };
const fieldStyles = mergeStyles({
  "& *": {
    width: "50px !important",
    height: "50px !important",
    fontSize: 35,
    textAlign: "center",
    // borderRadius: "5px !important",
  },
});
